import moment from "moment";
import React, { Component } from "react";
import Pagination from "react-js-pagination";
import Loader from "./../JobApplicationList/Loader";
import queryString from 'query-string';
import userlogo from '../../assets/images/user-logo.png'
import ReactReadMoreReadLess from "react-read-more-read-less";
import {
  applicationstatuslist,
  campusJobApplications,
  OffcampusJobApplications,
  UpdateOffCampusJobResponse,
  UpdateJobResponse,
  // getInterviewStatus,
  // setInterviewStatus,
  // addRemark
} from "./../../action/jobs";
import { getStorage, onChange, ToSeoUrl } from "../../utils";
import Shimmer from "../Common/Shimmer";
import FileSaver from "file-saver";
import constant from "../../constant";
import Swal from "sweetalert2";
import { ToastContainer, toast } from 'react-toastify';
import { withRouter } from "react-router-dom";
class JobApplicationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: { name: 'message', value: "", error: "" },
      JOB_ID: "",
      recuiterDetail: getStorage(constant.keys.userDetails),
      FILTER_BY: {
        name: "FILTER_BY",
        value: props.FILTER_BY ? props.FILTER_BY : "ALL",
        options: ["ALL", "CLOSED", "OPEN", "ON HOLD"],
        error: "",
      },
      LIMIT: {
        name: "LIMIT",
        value: props.LIMIT ? props.LIMIT : 10,
        options: [10, 20, 40, 50],
        error: "",
      },
      PAGE: { name: "PAGE", value: props.PAGE ? props.PAGE : 1, error: "" },
      KEYWORD: {
        name: "KEYWORD",
        value: props.KEYWORD ? props.KEYWORD : "",
        error: "",
        isRequired: true,
      },
      COUNT: undefined,
      SELECTION_PROCESS: props.SELECTION_PROCESS ? props.SELECTION_PROCESS : "",
      COMMENT: { name: "COMMENT", value: "", error: "", isRequired: true },
      jobActiveNess: {
        OPEN: ["CLOSED", "ON HOLD"],
        CLOSED: ["OPEN", "ON HOLD"],
        ON_HOLD: ["CLOSED", "OPEN"],
      },
      ShowEmailHover: false,
      APPLICATION_LIST: [],
      SelectedCandidate: [],
      AppliedCount: undefined,
      InterviewCount: undefined,
      InProgressCount: undefined,
      ShortlistedCount: undefined,
      OfferesAndJoiningCount: undefined,
      showForwardModal: false,
      statuslist: [],
      showEmailMassageModal: false,
      createLink: false,
      addMeeting: false,
      recrtMeetingUrl: "",
      selectedCandidateId: "",
      interviewTypeId: undefined,
      interviewStatusList: undefined,
      updateMeeting: undefined,
      updateMeetingNumber: undefined,
      scid: [],
      showLoader: undefined,
      showYoudoesnothaveHRMSModal: false,
      showYouhaveHRMSModal: false,
      org_id: undefined,
      role: undefined,
      designation: undefined,
      workLocation: undefined,
      department: undefined,
      shift: undefined,
      reportingaManager: undefined,
      employementType: undefined,
      CANDIDATE_ID: undefined,
      messageList: undefined,
      showRemarkModal: false,
      APPLICATION_ID: null,
      REMARKS: [],
      showViewRemarkModal: false

    };
  }

  showEmailHover = (input) => {
    this.setState({ ShowEmailHover: input });
  };
  componentDidMount() {
    this.loadlist();
  }
  onPageChange = (input) => {
    onChange(this, this.state.PAGE.name, input);
    this.props.onPageChange(input);
  };

  onChange = (e) => {
    const { name, value } = e.target;
    onChange(this, name, value);
    if (name === "LIMIT") {
      this.props.onLimitChange(value);
    }
  };
  onselectCandidate = (CANDIDATE_ID) => {
    let array = this.state.SelectedCandidate;
    const index = array.indexOf(CANDIDATE_ID);
    if (index > -1) {
      // only splice array when item is found
      array.splice(index, 1); // 2nd parameter means remove one item only
    } else {
      const str = CANDIDATE_ID;
      array.push(str);
    }

    this.setState({ SelectedCandidate: array });
  };

  downloadResume = (input) => {
    const RESUME_FILE = input.RESUME_FILE;
    const CANDIDATE_ID = input.CANDIDATE_ID;
    FileSaver.saveAs(
      `${process.env.REACT_APP_BASE_URL}/candidate-resume/${CANDIDATE_ID}/${RESUME_FILE}`,
      RESUME_FILE
    );
  };

  downloadSelectedCandidateResume = () => {
    if (this.state.SelectedCandidate.length > 0) {
      this.state.SelectedCandidate.map((i) => {
        this.state.APPLICATION_LIST.map((j) => {
          if (i == j.CANDIDATE_ID) {
            const model = {
              RESUME_FILE: j.RESUME_FILE,
              CANDIDATE_ID: j.CANDIDATE_ID,
            };
          }
        });
      });
    }

  };


  generateOfferLetter = (data, STATUS_ID) => {
    window.open(constant.component.LOI.url + `?candidate=${data?.CANDIDATE_NAME}&id=${data?.CANDIDATE_ID}&jid=${data?.JOB_ID}`, '_blank');
  }

  SendMessage = (e, item) => {

    if (e.keyCode == 13) {
      this.onAddMessage(item.CANDIDATE_ID)
    } else {
      this.onChange(e)
    }

  }
  changeSelectionProcess = (SELECTION_PROCESS) => {
    if (this.state.SELECTION_PROCESS !== SELECTION_PROCESS) {
      window.location.href =
        constant.component.CampusJobApplicationList.url +
        `?job=${ToSeoUrl(this.props.JOB_TITLE)}&id=${this.props.JOB_ID}&l=${this.state.LIMIT.value
        }&p=${1}&s=${SELECTION_PROCESS}`;
    }

  };
  onSelectAllCandidate = () => {
    if (
      this.state.SelectedCandidate.length !== this.state.APPLICATION_LIST.length
    ) {
      let array = this.state.APPLICATION_LIST.map((i) => {
        return i.CANDIDATE_ID;
      });
      this.setState({ SelectedCandidate: array });
    } else {
      this.setState({ SelectedCandidate: [] });
    }
  };



  onPageChange = (input) => {
    onChange(this, this.state.PAGE.name, input)
    this.props.onPageChange(input)
  }



  onselectCandidate = (CANDIDATE_ID) => {
    let array = this.state.SelectedCandidate
    const index = array.indexOf(CANDIDATE_ID);
    if (index > -1) { // only splice array when item is found
      array.splice(index, 1); // 2nd parameter means remove one item only
    }
    else {
      const str = CANDIDATE_ID
      array.push(str)
    }
    this.setState({ SelectedCandidate: array })
  }


  downloadResume = (input) => {
    const RESUME_FILE = input.RESUME_FILE
    const CANDIDATE_ID = input.CANDIDATE_ID
    FileSaver.saveAs(
      `${process.env.REACT_APP_BASE_URL}/candidate-resume/${CANDIDATE_ID}/${RESUME_FILE}`,
      RESUME_FILE
    );

  }

  downloadSelectedCandidateResume = () => {
    if (this.state.SelectedCandidate.length > 0) {
      this.state.SelectedCandidate.map(i => {
        this.state.APPLICATION_LIST.map(j => {
          if (i == j.CANDIDATE_ID) {
            const model = {
              RESUME_FILE: j.RESUME_FILE,
              CANDIDATE_ID: j.CANDIDATE_ID
            }
          }
        })
      })
    }
  }

  updateJobResponse = (data, STATUS_ID) => {
    debugger
    // if (STATUS_ID == 10) {
    //   this.generateOfferLetter(data, STATUS_ID)
    //   return true
    // }
    if (STATUS_ID == 11) {
      const model = {
        STATUS_ID: STATUS_ID,
        STUDENT_ID: data.STUDENT_ID,
        JOB_ID: this.props.JOB_ID
      }
      UpdateOffCampusJobResponse(model).then(res => {
        if (res.status) {
          this.loadlist()
        }
      }).catch(err => {
        console.log(err)
      })
      return true
    }


    if (data.APPLICATION_STATUS == STATUS_ID) {
      return false
    }

    const model = {
      STATUS_ID: STATUS_ID,
      STUDENT_ID: data.STUDENT_ID,
      JOB_ID: this.props.JOB_ID
    }

    UpdateOffCampusJobResponse(model).then(res => {
      if (res.status) {
        this.loadlist()
      }

    }).catch(err => {
      console.log(err)
    })

  }

  changeSelectionProcess = (SELECTION_PROCESS) => {
    if (this.state.SELECTION_PROCESS !== SELECTION_PROCESS) {
      window.location.href = constant.component.CampusJobApplicationList.url + `?job=${ToSeoUrl(this.props.JOB_TITLE)}&id=${this.props.JOB_ID}&l=${this.state.LIMIT.value}&p=${1}&s=${SELECTION_PROCESS}`
    }

  }
  onSelectAllCandidate = () => {
    if (this.state.SelectedCandidate.length !== this.state.APPLICATION_LIST.length) {
      let array = this.state.APPLICATION_LIST.map(i => {
        return i.CANDIDATE_ID
      })
      this.setState({ SelectedCandidate: array })
    }
    else {
      this.setState({ SelectedCandidate: [] })
    }
  }

  showForwardModal = () => {
    if (this.state.SelectedCandidate.length > 0) {
      this.setState({ showForwardModal: !this.state.showForwardModal })
    }
    else {
      Swal.fire({
        icon: "error",
        text: "Please Select Candidate To Send Message",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  }


  saveFile = (model) => {
    const { DOC_FILE_NAME, CANDIDATE_ID } = model
    FileSaver.saveAs(
      `${process.env.REACT_APP_BASE_URL}/candidate-doc-file/${CANDIDATE_ID}/${DOC_FILE_NAME}`,
      DOC_FILE_NAME
    );
  }






  onSearch = (e) => {
    e.preventDefault();
    const qParam = queryString.parse(this.props?.location?.search)
    if (this.state.KEYWORD.value?.length > 0) {
      window.location.href = constant.component.CampusJobApplicationList.url + `?job=${qParam?.job}&id=${qParam?.id}&l=${10}&p=${1}&s=all&k=${this.state.KEYWORD.value}`
    }
  }
  // onAddRemark = (model) => {
  //   model.APPLICATION_ID = this.state.APPLICATION_ID;
  //   addRemark(model).then(res => {

  //     if (res.status) {
  //       Swal.fire({
  //         icon: "success",
  //         text: 'Remark Added Successfully',
  //         timer: 1500,
  //         showCancelButton: false,
  //         showConfirmButton: false,
  //       });
  //       setTimeout(this.setState({ showRemarkModal: false }), 1500)
  //       this.loadlist()
  //     }
  //     else {
  //       Swal.fire({
  //         icon: "error",
  //         text: res.error,
  //         timer: 1500,
  //         showCancelButton: false,
  //         showConfirmButton: false,
  //       });
  //       setTimeout(this.setState({ showRemarkModal: false }), 1500)

  //     }
  //   })
  // }
  // openAddRemarkModal = (APPLICATION_ID) => {
  //   this.setState({ APPLICATION_ID: APPLICATION_ID, showRemarkModal: true })
  // }
  // openViewRemarkModal = (LIST) => {
  //   this.setState({ REMARKS: LIST, showViewRemarkModal: true })
  // }

  render() {
    const {
      statuslist,

      APPLICATION_LIST, COUNT, LIMIT, PAGE, SelectedCandidate, SELECTION_PROCESS, CANDIDATE_ID,
      AppliedCount, InterviewCount, InProgressCount, ShortlistedCount, OfferesAndJoiningCount,
      KEYWORD } = this.state
    const { ATS_ENABLED } = this.props;
    const qParam = queryString.parse(this.props?.location?.search)
    return (

      <React.Fragment>
        <section className='pricing-area padding-top-70px padding-bottom-80px'>

          <div className='filterareabox'>
            <div className='filterareasearch'>
              <div className='container'>
                <div className='row'>
                  <div className='col-md-10'>
                    <h1 className='pt-2'>Requirementss : {this.props.JOB_TITLE} /<span>Off Campus Applications</span></h1>
                  </div>
                  <div className='col-md-2 text-right'>
                    <h3>{COUNT} <span className='font-size-12'>Profile(s)</span></h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-md-8">
                  <div className="paginationshowbox" style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <span>
                      Showing {LIMIT.value * PAGE.value - (LIMIT.value - 1)} to{" "}
                      {COUNT >= LIMIT.value * PAGE.value
                        ? LIMIT.value * PAGE.value
                        : LIMIT.value * PAGE.value -
                        (LIMIT.value * PAGE.value - COUNT)}{" "}
                      of {COUNT}
                    </span>
                    <ul>
                      <Pagination
                        activePage={PAGE.value}
                        itemsCountPerPage={LIMIT.value}
                        totalItemsCount={COUNT ? COUNT : 0}
                        pageRangeDisplayed={5}
                        onChange={this.onPageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                      />
                    </ul>
                  </div>
                </div>
                <div className="col-md-4">
                  {/* <div className="pagenumnerarea justify-content-end">
                    <p>Show</p>
                    <select
                      name={LIMIT.name}
                      value={LIMIT.value}
                      onChange={this.onChange}
                    >

                      {LIMIT.options.map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                    </select>
                    <p>Per Page</p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">

              {COUNT === undefined && (
                <div className="col-md-12">
                  <Shimmer />
                </div>
              )}
              {COUNT !== undefined && (
                <div className="col-md-12">
                  <div className="search-box-top">
                    <div className="search-box">
                      <form className="rseachbox" onSubmit={this.onSearch}>
                        <input
                          name={KEYWORD.name}
                          value={KEYWORD.value}
                          onChange={this.onChange}
                          type="text"
                          placeholder="Search  Candidate"
                        />
                        <button type="submit">
                          Search <i className="fa fa-search" aria-hidden="true" />
                        </button>
                      </form>
                    </div>


                    <div className="filte-and-email-bx">
                      <div className="limet-page-bx">
                        <div className="pagenumnerarea justify-content-end">
                          <div
                            className="applymatchin-box mr-3"
                            onClick={()=>{
                              this.props.onTabChange('on_campus')
                          }}
                          >
                            <a className="applymatchin-btn">
                              View On Campus Applications
                            </a>

                          </div>

                          <select
                            name={LIMIT.name}
                            value={LIMIT.value}
                            onChange={this.onChange}
                          >

                            {LIMIT.options.map((item) => {
                              return <option value={item}>{item}</option>;
                            })}
                          </select>
                          <p>Per Page</p>
                        </div>

                      </div>


                    </div>


                  </div>

                  <div className="top-tab-section">

                    <ul className="top-tab-list">
                      <li className={SELECTION_PROCESS === "all"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("all");
                        }} >All</a></li>
                      <li className={SELECTION_PROCESS === "applied"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("applied");
                        }}>Applied ({AppliedCount})</a></li>
                      <li className={SELECTION_PROCESS === "shortlisted"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("shortlisted");
                        }}>Shortlisted ({ShortlistedCount})</a></li>
                      <li className={SELECTION_PROCESS === "interview"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("interview");
                        }} >Interview ({InterviewCount})</a></li>
                      <li className={SELECTION_PROCESS === "offerandjoining"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("offerandjoining");
                        }} >Offers & Joining ({OfferesAndJoiningCount}) </a></li>
                      <li className={SELECTION_PROCESS === "inprogress"
                        ? "active"
                        : ""}><a onClick={() => {
                          this.changeSelectionProcess("inprogress");
                        }} >In Process ({InProgressCount})</a></li>
                    </ul>
                  </div>
                  {
                    APPLICATION_LIST.length > 0 ? APPLICATION_LIST.map((item, index) => {
                      return (
                        <div className="lob-list-item jm-job-layout-2">

                          <div className="jm-latest-job-item-3 mb-30">
                            <div className="jm-latest-job-item-top-3">
                              <div className="jm-latest-job-item-top-wrap-3">
                                <div className="prof-info-bx">
                                  <div className="jm-latest-job-item-logo-3 y_img">
                                    <a >
                                      <img src={item.PROFILE_IMAGE ? `${process.env.REACT_APP_BASE_URL}/student/pic/${item.STUDENT_ID}/${item.PROFILE_IMAGE}` : userlogo} alt="" />
                                    </a>
                                  </div>
                                  <div className="jm-latest-job-item-info-3">
                                    <h3 className="jm-latest-job-item-info-title-3">

                                      <div>

                                        <span>&nbsp;{item.FIRST_NAME + ' ' + item.LAST_NAME}</span>
                                      </div>
                                      <div>
                                        <span>
                                          <a href={"tel:" + item.PHONE}> <i class="fa fa-phone" aria-hidden="true"></i> {item.PHONE}</a>
                                        </span>
                                        &nbsp;
                                        &nbsp;
                                        &nbsp;
                                        &nbsp;

                                        <span>
                                          <a href={"mailto:" + item.PERSONAL_EMAIL}> <i class="fa fa-envelope" aria-hidden="true"></i> {item.PERSONAL_EMAIL}</a>
                                        </span>


                                      </div>
                                    </h3>
                                    <p className="jm-latest-job-item-info-subtitle-3" >
                                      {/* {item.PROFILE_SUMMARY != null
                                        ? <ReactReadMoreReadLess
                                          charLimit={250}
                                          readMoreText={"Read more"}
                                          readLessText={"Read less"}
                                        >
                                          {(item.PROFILE_SUMMARY)}
                                        </ReactReadMoreReadLess>

                                        : "Not Available"
                                      } */}
                                    </p>

                                  </div>
                                </div>
                                <div className="other-info-box first">
                                  <div className="key-info key-info-first">
                                    <h5>Education:</h5>
                                  </div>
                                  <div className="jm-latest-job-meta-wrapper key-info-second">
                                    <ul className="list-job-info">
                                      <li><span><i class="fa fa-laptop"></i>  Course:</span> {item.COURSE_STREAM}{item.SPECIALIZATION && ' ( ' + item.SPECIALIZATION + ' ) '}</li>
                                      
                                      <li><span><i className="fa fa-graduation-cap"></i> College:</span> --</li>
                                      {/* <li><span><i className="fa fa-university"></i> University:</span> --</li> */}
                                    </ul>
                                  </div>
                                </div>
                                {/* <div className="other-info-box second">
                                  <div className="key-info key-info1">
                                    <h5>Key skills:</h5>

                                  </div>
                                  <div className="jm-latest-job-meta-wrapper">
                                    
                                  </div>
                                </div> */}
                              </div>
                              <div className="jm-latest-job-item-btn-3">
                                <a className="applied-date jm-theme-btn">Applied On {moment(item.CREATED_ON).format("DD MMM YYYY")}{" "}</a>
                                <a
                                  className="jm-theme-btn jm-sendmail-btn"

                                >
                                  {item.APPLICATION_STATUS}
                                </a>
                                {
                                  <a className="jm-theme-btn jm-resume-down-btn"
                                  // onClick={() => {
                                  //   this.downloadResume(item);
                                  // }}
                                  >
                                    <i className="fa fa-download"></i>  View Resume
                                  </a>

                                }
                                {/* {item.DOCS_LINK && <a
                                  onClick={() => { this.saveFile({ DOC_FILE_NAME: item.DOCS_LINK, CANDIDATE_ID: item.CANDIDATE_ID }) }}
                                  className="jm-theme-btn jm-resume-down-btn"
                                >
                                  <i className="fa fa-file-text-o"></i>  Documents
                                </a>
                                } */}


                                <div className="applymatchin-box">
                                  <a
                                    href="javascript:void(0)"
                                    className="applymatchin-btn dropdown-toggle"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    Applied - Matching
                                  </a>

                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >

                                    {statuslist.map((i) => {
                                      return (
                                        <a
                                          class="dropdown-item"
                                          onClick={() => {
                                            this.updateJobResponse(
                                              item,
                                              i.STATUS_ID
                                            );
                                          }}
                                          href="javascript:void(0)"
                                        >
                                          {i.STATUS_NAME}
                                        </a>
                                      );
                                    })}

                                  </div>
                                  <a
                                    href="javascript:void(0)"
                                    onClick={() => {
                                      this.updateJobResponse(item, 5);
                                    }}
                                    className="reject-btn"
                                  >
                                    {item.APPLICATION_STATUS == 5
                                      ? "Rejected"
                                      : "Reject"}
                                  </a>
                                </div>

                              </div>
                            </div>

                          </div>



                        </div>)
                    }) : <div className="lob-list-item jm-job-layout-2" style={{ textAlign: 'center', fontSize: '15px' }}>
                      <div className="jm-latest-job-item-3 mb-30">
                        <div className="jm-latest-job-item-top-3">
                          <div className="jm-latest-job-item-top-wrap-3">
                            No Application received.
                            <a className="pr-1" target='_blank' href={constant.component.editJob.url + "?job=" + ToSeoUrl(qParam.job) + "&i=" + qParam.id} > Click here</a>
                            to update job to increase the responses.
                          </div > </div > </div > </div>}
                </div >
              )
              }
            </div>
          </div >

          {this.state.showLoader && <Loader />}

          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          {/* Same as */}
          <ToastContainer />
        </section >

      </React.Fragment >
    );
  }



  loadlist = () => {

    const { LIMIT, PAGE, KEYWORD, SELECTION_PROCESS } = this.state;
    OffcampusJobApplications({
      page: PAGE.value,
      limit: LIMIT.value,
      keyword: KEYWORD.value,
      JOB_ID: this.props.JOB_ID,
      SELECTION_PROCESS: SELECTION_PROCESS,
    }).then((res) => {
      debugger
      if (res.status) {
        this.setState({
          APPLICATION_LIST: res.result.list,
          COUNT: res.result.count,
          AppliedCount: res.result.AppliedCount,
          InterviewCount: res.result.InterviewCount,
          InProgressCount: res.result.InProgressCount,
          ShortlistedCount: res.result.ShortlistedCount,
          OfferesAndJoiningCount: res.result.OfferesAndJoiningCount,
        });
      } else {
        Swal.fire({
          icon: 'error',
          text: res.error,
          timer: 1500,
          showCancelButton: false,
          showConfirmButton: false
        })
        console.log(res.error);
      }
    })
      .catch((err) => {
        console.log(err);
      });

    applicationstatuslist().then((res) => {

      if (res.status) {
        this.setState({ statuslist: res.result });
      }

    });


  };




}
export default withRouter(JobApplicationList)



